import { render, staticRenderFns } from "./PhuGrid.vue?vue&type=template&id=fde14204&scoped=true"
import script from "./PhuGrid.vue?vue&type=script&lang=js"
export * from "./PhuGrid.vue?vue&type=script&lang=js"
import style0 from "./PhuGrid.vue?vue&type=style&index=0&id=fde14204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde14204",
  null
  
)

export default component.exports